import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: 53,
  },
  toolbar: {
    padding: 0,

    '& .MuiTablePagination-caption:nth-of-type(1)': {
      display: 'none',
    },
  },
  menuItem: {
    fontSize: theme.typography.appFontSize,
  },
  input: {
    marginRight: 15,
  },
  selectRoot: {
    display: 'none',
  },
  actions: {
    marginLeft: 5,
  },
}));

export default useStyles;
